
const dataPrograms =

[
  {
    "index": 0,
    "program": [0, 0, 0, 30, 0, 3, 1, 1, 127, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  },
  {
    "index": 1,
    "program": [0, 0, 0, 0, 1, 3, 0, 2, 127, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  },
  // {
  //   "index": 2,
  //   "program": [0, 0, 3, 72, 2, 1, 1, 16, 76, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  // },
  // {
  //   "index": 3,
  //   "program": [0, 0, 3, 132, 3, 1, 0, 16, 76, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  // },
  {
    "index": 2,
    // "index": 4,
    "program": [0, 0, 3, 192, 4, 1, 1, 16, 127, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  },
  {
    "index": 3,
    // "index": 5,
    "program": [0, 0, 3, 252, 5, 1, 0, 16, 127, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  }
]

// [
//   {
//     "index": 0,
//     "program": [0, 0, 0, 30, 0, 3, 1, 1, 127, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
//   },
//   {
//     "index": 1,
//     "program": [0, 0, 0, 0, 1, 3, 0, 2, 127, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
//   },
//   {
//     "index": 2,
//     "program": [0, 0, 3, 72, 2, 1, 1, 16, 76, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
//   },
//   {
//     "index": 3,
//     "program": [0, 0, 3, 132, 3, 1, 0, 16, 76, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
//   }
// ]
export default dataPrograms;
